import client from '../session/apiClient';

export default {
  getCountries: () => {
    return client.get("/admin/location/editorData")
      .then(resp => {
        return resp.data["countriesWithFullName"]
      })
  }
};
